import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./Pages/Components/ScrollToTop";
import Header from "./Pages/Components/header";
import Home from "./Pages/Components/home";
import About from "./Pages/Components/about";
import News from "./Pages/Components/news";
import Partner from "./Pages/Components/partner";
import BecomePartner from "./Pages/Components/becomePartner";
import Footer from "./Pages/Components/footer";

import NewsList from "./Pages/Components/newsList";
import LampSingle from "./Pages/Components/LampSingle";
function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Header />

        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/news" element={<News />} />
          <Route exact path="/NewsList/:id" element={<NewsList />} />
          <Route exact path="/partner" element={<Partner />} />
          <Route exact path="/becomepartner" element={<BecomePartner />} />
          <Route exact path="/lamp/:slug" element={<LampSingle />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
